export const UserRoles = {
  Student: 'student',
  Tutor: 'tutor',
};
